import { useEffect } from 'react';
import { image } from '../../../../../utils/data/baseUrl';
import { conturs, defaultContur } from '../../../../../translations';
import { useUser } from '../../../../../redux/reducer/user';
import { useModalsDataActions } from '../../../../../hooks/useModalsDataActions';
import { useAppState, useOnboarding } from '../../../../../redux/reducer/content';
import { MAIN, SETS } from '../../../../../constants/shared/states/names';
import useServiceData from '../../../../../hooks/useServiceData';
import useStateControls from '../../../../../hooks/useStateControls';

const showedModals = {
  lootboxes: false,
};

export default function useSeasonModals() {
  const {
    profile: { gachaModal, premiumAdded },
  } = useUser();
  const state = useAppState();
  const { get, save } = useServiceData();
  const { addModal } = useModalsDataActions();
  const { seasonModalsVisible } = useOnboarding();
  const { setState } = useStateControls();

  const isMeContur = defaultContur === conturs.me;

  useEffect(() => {
    if (state !== MAIN || !seasonModalsVisible) return;

    const modalsData = get('modalsData') ?? {};
    const { idModal, count } = gachaModal ?? {};

    const lootboxesModalKey = `seasonModal6${idModal}`;
    const isHasLootboxesModal = !modalsData[lootboxesModalKey] && !!idModal && count > 0 && !showedModals.lootboxes;

    if (isHasLootboxesModal) {
      showedModals.lootboxes = true;
      save('modalsData', { ...modalsData, [lootboxesModalKey]: true });

      addModal({
        id: 'onboardingModal',
        type: 'onboardingModal',
        props: {
          image: isMeContur ? image('seasonModals/gift.png') : image('seasonModals/box.png'),
          title: 'helpContent.main.lootBoxes2026.title',
          description: 'helpContent.main.lootBoxes2026.description',
          buttons: [
            {
              attr: {
                text: 'helpContent.main.lootBoxes2026.buttonText',
                disposable: true,
                customCallbacks: { setState },
                callbackKey: 'setState',
                callbackOptions: SETS,
                modalData: {
                  action: 'close',
                  data: { type: 'current' },
                },
              },
            },
            {
              attr: {
                text: 'other.continue',
                disposable: true,
                className: 'custom-button_gray',
                modalData: { action: 'close', data: { type: 'current' } },
              },
            },
          ],
        },
      });
    }
  }, [gachaModal, seasonModalsVisible, premiumAdded, state]);
}
